import { useAuthContext } from '@/context/AuthContext';
import { AdobeAnalyticsConst } from '../adobeAnalyticsConstants/adobeAnalyticsConstants';
import { AdobeAnalyticsUserRole } from '../AdobeAnalyticsUserRole';
import { useCallback } from 'react';
import { AnalyticsPayload, FormEventType } from '../types/AdobeAnalyticsTypes';
import { useEventTracker } from '../eventTracker/useEventTracker';

export const useRegistrationForm = () => {
  const { userInfo } = useAuthContext();
  const formTotalStep = 3;

  const userRole = userInfo?.adobeAnalyticsRole ?? AdobeAnalyticsUserRole.ANONYMOUS;

  const buildPayload = useCallback(
    (formData: { event: FormEventType }): AnalyticsPayload[] => {
      const stepMap: Record<FormEventType, number> = {
        [AdobeAnalyticsConst.FORM.START]: 1,
        [AdobeAnalyticsConst.FORM.STEP]: 2,
        [AdobeAnalyticsConst.FORM.SUCCESS]: 3,
      };

      const step = stepMap[formData.event];

      if (step === undefined) {
        return [];
      }

      const timestamp = new Date().toISOString();

      const payload: AnalyticsPayload[] = [
        {
          timestamp,
          content: {
            form: {
              name: AdobeAnalyticsConst.FORM.NAME,
              type: AdobeAnalyticsConst.FORM.TYPE,
              step,
              stepsTotal: formTotalStep,
            },
          },
        },
      ];

      if (step === 3) {
        payload.push({
          event: AdobeAnalyticsConst.FORM.USER_REGISTRATION,
          timestamp,
          user: {
            position: userRole,
          },
        });
      }

      return payload;
    },
    [userRole],
  );

  const trackEvent = useEventTracker(AdobeAnalyticsConst.FORM.START, buildPayload);

  return { trackUserRegistration: trackEvent };
};
